let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d38ji")).then(() => parcelRequire('hDG8o'));